export default "__VITE_ASSET__Cqpax4Pe__"